/* eslint-disable */
import _ from 'underscore';
import * as putils from '@bingads-webui-universal/primitive-utilities';
var i18n = window.globalLegacyI18n.get('component/i18n/loader!component/address');
function postalCodeSchema(countryCode) {
  var isRequired = false, result = {}, title_postal_code = i18n.get('Address_PostalCode'), title_zip = i18n.get('Address_Zip');
  switch (countryCode) {
    case 'US':
    case 'GU':
      result = {
        Title: isRequired ? title_zip : i18n.get('Address_Title_Optional', {
          title: title_zip
        }),
        Pattern: /^[0-9]{5}(\-[0-9]{4})?$/,
        Required: isRequired,
        IsZip: true
      };
      break;
    case 'CA':
      result = {
        Title: isRequired ? title_postal_code : i18n.get('Address_Title_Optional', {
          title: title_postal_code
        }),
        Pattern: /^[abceghjklmnprstvxyABCEGHJKLMNPRSTVXY]{1}\d{1}[a-zA-Z]{1}[ -]?\d{1}[a-zA-Z]{1}\d{1}$/,
        Required: isRequired,
        IsZip: false
      };
      break;
    case 'AT':
    case 'CH':
    case 'DK':
    case 'NO':
    case 'ZA':
    case 'HU':
    case 'SI':
    case 'LU':
    case 'AL':
    case 'MK':
    case 'PA':
    case 'BO':
    case 'PY':
    case 'SV':
    case 'BD':
    case 'ET':
    case 'GE':
    case 'AM':
    case 'CG':
    case 'NE':
    case 'TN':
      result = {
        Title: isRequired ? title_postal_code : i18n.get('Address_Title_Optional', {
          title: title_postal_code
        }),
        Pattern: /^[0-9]{4}$/,
        Required: isRequired,
        IsZip: false
      };
      break;
    case 'DE':
    case 'ES':
    case 'FI':
    case 'FR':
    case 'IT':
    case 'MX':
    case 'PE':
    case 'TR':
    case 'MC':
    case 'SR':
    case 'BA':
    case 'ME':
    case 'DO':
    case 'UY':
    case 'GT':
    case 'HN':
    case 'LK':
    case 'NP':
    case 'MN':
    case 'PK':
    case 'MU':
    case 'TZ':
    case 'RE':
    case 'IQ':
    case 'DZ':
    case 'ZM':
    case 'SN':
    case 'VI':
      result = {
        Title: isRequired ? title_postal_code : i18n.get('Address_Title_Optional', {
          title: title_postal_code
        }),
        Pattern: /^[0-9]{5}$/,
        Required: isRequired,
        IsZip: false
      };
      break;
    case 'CO':
    case 'VN':
    case 'RO':
    case 'EC':
    case 'TT':
    case 'NG':
    case 'MW':
    case 'KG':
    case 'TJ':
      result = {
        Title: isRequired ? title_postal_code : i18n.get('Address_Title_Optional', {
          title: title_postal_code
        }),
        Pattern: /^[0-9]{6}$/,
        Required: isRequired,
        IsZip: false
      };
      break;
    case 'IL':
      result = {
        Title: isRequired ? title_postal_code : i18n.get('Address_Title_Optional', {
          title: title_postal_code
        }),
        Pattern: /^[0-9]{7}$/,
        Required: isRequired,
        IsZip: false
      };
      break;
    case 'LY':
      result = {
        Title: isRequired ? title_postal_code : i18n.get('Address_Title_Optional', {
          title: title_postal_code
        }),
        Pattern: /^([1-9][1-9](.)[1-9][1-9](.)[1-9][1-9][1-9])$/,
        Required: isRequired,
        IsZip: false
      };
      break;
    case 'GR':
      result = {
        Title: isRequired ? title_postal_code : i18n.get('Address_Title_Optional', {
          title: title_postal_code
        }),
        Pattern: /^([0-8][0-9]{2} ?[0-9]{2})|(900 ?00)$/,
        Required: isRequired,
        IsZip: false
      };
      break;
    case 'PL':
      result = {
        Title: isRequired ? title_postal_code : i18n.get('Address_Title_Optional', {
          title: title_postal_code
        }),
        Pattern: /^[0-9]{2}[-][0-9]{3}$/,
        Required: isRequired,
        IsZip: false
      };
      break;
    case 'PT':
      result = {
        Title: isRequired ? title_postal_code : i18n.get('Address_Title_Optional', {
          title: title_postal_code
        }),
        Pattern: /^[0-9]{4}(-[0-9]{3})?$/,
        Required: isRequired,
        IsZip: false
      };
      break;
    case 'CZ':
    case 'SK':
      result = {
        Title: isRequired ? title_postal_code : i18n.get('Address_Title_Optional', {
          title: title_postal_code
        }),
        Pattern: /^[0-9]{3} [0-9]{2}$/,
        Required: isRequired,
        IsZip: false
      };
      break;
    case 'BG':
    case 'LI':
      result = {
        Title: isRequired ? title_postal_code : i18n.get('Address_Title_Optional', {
          title: title_postal_code
        }),
        Pattern: /^[1-9][0-9]{3}$/,
        Required: isRequired,
        IsZip: false
      };
      break;
    case 'HR':
    case 'EE':
    case 'EG':
      result = {
        Title: isRequired ? title_postal_code : i18n.get('Address_Title_Optional', {
          title: title_postal_code
        }),
        Pattern: /^[1-9][0-9]{4}$/,
        Required: isRequired,
        IsZip: false
      };
      break;
    case 'LT':
      result = {
        Title: isRequired ? title_postal_code : i18n.get('Address_Title_Optional', {
          title: title_postal_code
        }),
        Pattern: /^([lL][tT]-?)?[0-9]{5}$/,
        Required: isRequired,
        IsZip: false
      };
      break;
    case 'LV':
      result = {
        Title: isRequired ? title_postal_code : i18n.get('Address_Title_Optional', {
          title: title_postal_code
        }),
        Pattern: /^([Ll][Vv]-?)?[0-9]{4}$/,
        Required: isRequired,
        IsZip: false
      };
      break;
    case 'CY':
      result = {
        Title: isRequired ? title_postal_code : i18n.get('Address_Title_Optional', {
          title: title_postal_code
        }),
        Pattern: /^(SE-?)?[0-9]{4}$/,
        Required: isRequired,
        IsZip: false
      };
      break;
    case 'MT':
      result = {
        Title: isRequired ? title_postal_code : i18n.get('Address_Title_Optional', {
          title: title_postal_code
        }),
        Pattern: /^[a-zA-Z]{3} [0-9]{4}$/,
        Required: isRequired,
        IsZip: false
      };
      break;
    case 'MD':
      result = {
        Title: isRequired ? title_postal_code : i18n.get('Address_Title_Optional', {
          title: title_postal_code
        }),
        Pattern: /^[a-zA-Z]{2}[ \-]?[0-9]{4}$/,
        Required: isRequired,
        IsZip: false
      };
      break;
    case 'IS':
      result = {
        Title: isRequired ? title_postal_code : i18n.get('Address_Title_Optional', {
          title: title_postal_code
        }),
        Pattern: /^([1-9][0-9]{2}|[0-9]{5})$/,
        Required: isRequired,
        IsZip: false
      };
      break;
    case 'BN':
      result = {
        Title: isRequired ? title_postal_code : i18n.get('Address_Title_Optional', {
          title: title_postal_code
        }),
        Pattern: /^((B)[A-H|J-N|P|R-U]\d{4,4}|(K)[A-H]\d{4,4}|(P)[A-E]\d{4,4}|(T)[A-H]\d{4,4})$/,
        Required: isRequired,
        IsZip: false
      };
      break;
    case 'NC':
      result = {
        Title: isRequired ? title_postal_code : i18n.get('Address_Title_Optional', {
          title: title_postal_code
        }),
        Pattern: /^((988)\d{2,2})$/,
        Required: isRequired,
        IsZip: false
      };
      break;
    case 'KY':
      result = {
        Title: isRequired ? title_postal_code : i18n.get('Address_Title_Optional', {
          title: title_postal_code
        }),
        Pattern: /^((KY)[1-3](-)\d{4,4})$/,
        Required: isRequired,
        IsZip: false
      };
      break;
    case 'PG':
      result = {
        Title: isRequired ? title_postal_code : i18n.get('Address_Title_Optional', {
          title: title_postal_code
        }),
        Pattern: /^([1][1-9][0-9]|[2-5][0-9][0-9]|(6)[0-3][0-9]|(640)|(641))$/,
        Required: isRequired,
        IsZip: false
      };
      break;
    case 'PF':
      result = {
        Title: isRequired ? title_postal_code : i18n.get('Address_Title_Optional', {
          title: title_postal_code
        }),
        Pattern: /^((987)[0-9][0-9])$/,
        Required: isRequired,
        IsZip: false
      };
      break;
    case 'HT':
      result = {
        Title: isRequired ? title_postal_code : i18n.get('Address_Title_Optional', {
          title: title_postal_code
        }),
        Pattern: /^((HT)[11-17|21-24|31-33|41-45|51-54|61-65|71-75|81-85|91-93]\d{2,2})|((HT )[11-17|21-24|31-33|41-45|51-54|61-65|71-75|81-85|91-93]\d{2,2})$/,
        Required: isRequired,
        IsZip: false
      };
      break;
    case 'MQ':
      result = {
        Title: isRequired ? title_postal_code : i18n.get('Address_Title_Optional', {
          title: title_postal_code
        }),
        Pattern: /^((972)\d{2,2})$/,
        Required: isRequired,
        IsZip: false
      };
      break;
    case 'PR':
      result = {
        Title: isRequired ? title_postal_code : i18n.get('Address_Title_Optional', {
          title: title_postal_code
        }),
        Pattern: /^([0-9]{5}[ -]?[0-9]{4})|[0-9]{5}$/,
        Required: isRequired,
        IsZip: false
      };
      break;
    case 'CR':
      result = {
        Title: isRequired ? title_postal_code : i18n.get('Address_Title_Optional', {
          title: title_postal_code
        }),
        Pattern: /^[0-9]{4,5}$/,
        Required: isRequired,
        IsZip: false
      };
      break;
    case 'PF':
      result = {
        Title: isRequired ? title_postal_code : i18n.get('Address_Title_Optional', {
          title: title_postal_code
        }),
        Pattern: /^((973)[0-9][0-9])$/,
        Required: isRequired,
        IsZip: false
      };
      break;
    case 'MS':
      result = {
        Title: isRequired ? title_postal_code : i18n.get('Address_Title_Optional', {
          title: title_postal_code
        }),
        Pattern: /^((MSR)[1][1-3][1-3,5][0])$/,
        Required: isRequired,
        IsZip: false
      };
      break;
    case 'MV':
      result = {
        Title: isRequired ? title_postal_code : i18n.get('Address_Title_Optional', {
          title: title_postal_code
        }),
        Pattern: /^([0-1]\d{4,4}|[2][0-1]\d{3,3})$/,
        Required: isRequired,
        IsZip: false
      };
      break;
    case 'JP':
      result = {
        Title: isRequired ? title_postal_code : i18n.get('Address_Title_Optional', {
          title: title_postal_code
        }),
        Pattern: /^[0-9]{3}[-]?[0-9]{4}$/,
        Required: isRequired,
        IsZip: false
      };
      break;
    case 'AZ':
      result = {
        Title: isRequired ? title_postal_code : i18n.get('Address_Title_Optional', {
          title: title_postal_code
        }),
        Pattern: /^[aA][zZ] ?[0-9]{4}$/,
        Required: isRequired,
        IsZip: false
      };
      break;
    case 'NA':
      result = {
        Title: isRequired ? title_postal_code : i18n.get('Address_Title_Optional', {
          title: title_postal_code
        }),
        Pattern: /^[10-23]{2,2}[0][0-3][0-9]$/,
        Required: isRequired,
        IsZip: false
      };
      break;
    case 'MG':
    case 'LS':
    case 'GN':
    case 'OM':
      result = {
        Title: isRequired ? title_postal_code : i18n.get('Address_Title_Optional', {
          title: title_postal_code
        }),
        Pattern: /^([0-9]{3})$/,
        Required: isRequired,
        IsZip: false
      };
    case 'BH':
    case 'FO':
      result = {
        Title: isRequired ? title_postal_code : i18n.get('Address_Title_Optional', {
          title: title_postal_code
        }),
        Pattern: /^[0-9]{3,4}$/,
        Required: isRequired,
        IsZip: false
      };
      break;
    case 'GI':
      result = {
        Title: isRequired ? title_postal_code : i18n.get('Address_Title_Optional', {
          title: title_postal_code
        }),
        Pattern: /^GX11 1AA$/,
        Required: isRequired,
        IsZip: false
      };
      break;
    case 'SO':
      result = {
        Title: isRequired ? title_postal_code : i18n.get('Address_Title_Optional', {
          title: title_postal_code
        }),
        Pattern: /^((AD|BK|BN|BR|BY|GG|GD|HR|JD|JH|MD|NG|SG|SD|SH|SOL|TG|WG)( )\d{5,5})$/,
        Required: isRequired,
        IsZip: false
      };
      break;
    case 'MH':
      result = {
        Title: isRequired ? title_postal_code : i18n.get('Address_Title_Optional', {
          title: title_postal_code
        }),
        Pattern: /^((969)[0-9][0-9]|(969)[0-9][0-9](-)[0-9][0-9][0-9][0-9])$/,
        Required: isRequired,
        IsZip: false
      };
      break;
    case 'KN':
      result = {
        Title: isRequired ? title_postal_code : i18n.get('Address_Title_Optional', {
          title: title_postal_code
        }),
        Pattern: /^((KN)[0-9][0-9][0-9][0-9])$/,
        Required: isRequired,
        IsZip: false
      };
      break;
    case 'AS':
      result = {
        Title: isRequired ? title_postal_code : i18n.get('Address_Title_Optional', {
          title: title_postal_code
        }),
        Pattern: /^(96799|96799[-][0-9][0-9][0-9][0-9])$/,
        Required: isRequired,
        IsZip: false
      };
      break;
    case 'VG':
      result = {
        Title: isRequired ? title_postal_code : i18n.get('Address_Title_Optional', {
          title: title_postal_code
        }),
        Pattern: /^(VG11[1-6]0)$/,
        Required: isRequired,
        IsZip: false
      };
      break;
    case 'LC':
      result = {
        Title: isRequired ? title_postal_code : i18n.get('Address_Title_Optional', {
          title: title_postal_code
        }),
        Pattern: /^((LC)[0-9][0-9]( )[0-9][0-9][0-9])$/,
        Required: isRequired,
        IsZip: false
      };
      break;
    case 'BM':
      result = {
        Title: isRequired ? title_postal_code : i18n.get('Address_Title_Optional', {
          title: title_postal_code
        }),
        Pattern: /^[a-zA-Z]{2}[ \-]?[0-9]{2}$/,
        Required: isRequired,
        IsZip: false
      };
      break;
    case 'VC':
      result = {
        Title: isRequired ? title_postal_code : i18n.get('Address_Title_Optional', {
          title: title_postal_code
        }),
        Pattern: /^((VC0)[1-3]\d{2,2}|(VC04)[0-7]\d{1,1})$/,
        Required: isRequired,
        IsZip: false
      };
      break;
    case 'BB':
      result = {
        Title: isRequired ? title_postal_code : i18n.get('Address_Title_Optional', {
          title: title_postal_code
        }),
        Pattern: /^[a-zA-Z]{2}[0-9]{5}$/,
        Required: isRequired,
        IsZip: false
      };
      break;
    case 'AI':
      result = {
        Title: isRequired ? title_postal_code : i18n.get('Address_Title_Optional', {
          title: title_postal_code
        }),
        Pattern: /^(AI-2640)$/,
        Required: isRequired,
        IsZip: false
      };
      break;
    case 'GL':
      result = {
        Title: isRequired ? title_postal_code : i18n.get('Address_Title_Optional', {
          title: title_postal_code
        }),
        Pattern: /^((39)[0-9][0-9])$/,
        Required: isRequired,
        IsZip: false
      };
      break;
    case 'JM':
      result = {
        Title: isRequired ? title_postal_code : i18n.get('Address_Title_Optional', {
          title: title_postal_code
        }),
        Pattern: /^[0-9]{1,2}$/,
        Required: isRequired,
        IsZip: false
      };
      break;
    case 'MP':
      result = {
        Title: isRequired ? title_postal_code : i18n.get('Address_Title_Optional', {
          title: title_postal_code
        }),
        Pattern: /^((9695)[0-9]|(9695)[0-9](-)[0-9][0-9][0-9][0-9])$/,
        Required: isRequired,
        IsZip: false
      };
      break;
    case 'CC':
      result = {
        Title: isRequired ? title_postal_code : i18n.get('Address_Title_Optional', {
          title: title_postal_code
        }),
        Pattern: /^(6799)$/,
        Required: isRequired,
        IsZip: false
      };
      break;
    case 'CX':
      result = {
        Title: isRequired ? title_postal_code : i18n.get('Address_Title_Optional', {
          title: title_postal_code
        }),
        Pattern: /^(6798)$/,
        Required: isRequired,
        IsZip: false
      };
      break;
    case 'GP':
      result = {
        Title: isRequired ? title_postal_code : i18n.get('Address_Title_Optional', {
          title: title_postal_code
        }),
        Pattern: /^((970)[0-9][0-9]|(971)[0-9][0-9])$/,
        Required: isRequired,
        IsZip: false
      };
      break;
    case 'GW':
      result = {
        Title: isRequired ? title_postal_code : i18n.get('Address_Title_Optional', {
          title: title_postal_code
        }),
        Pattern: /^\d{4,4}$/,
        Required: isRequired,
        IsZip: false
      };
      break;
    case 'NF':
      result = {
        Title: isRequired ? title_postal_code : i18n.get('Address_Title_Optional', {
          title: title_postal_code
        }),
        Pattern: /^((2899))$/,
        Required: isRequired,
        IsZip: false
      };
      break;
    case 'NR':
      result = {
        Title: isRequired ? title_postal_code : i18n.get('Address_Title_Optional', {
          title: title_postal_code
        }),
        Pattern: /^(NRU68)$/,
        Required: isRequired,
        IsZip: false
      };
      break;
    case 'NU':
      result = {
        Title: isRequired ? title_postal_code : i18n.get('Address_Title_Optional', {
          title: title_postal_code
        }),
        Pattern: /^(9974)$/,
        Required: isRequired,
        IsZip: false
      };
      break;
    case 'PM':
      result = {
        Title: isRequired ? title_postal_code : i18n.get('Address_Title_Optional', {
          title: title_postal_code
        }),
        Pattern: /^((975)\d{2,2})$/,
        Required: isRequired,
        IsZip: false
      };
      break;
    case 'PN':
      result = {
        Title: isRequired ? title_postal_code : i18n.get('Address_Title_Optional', {
          title: title_postal_code
        }),
        Pattern: /^((PCRN 1ZZ))$/,
        Required: isRequired,
        IsZip: false
      };
      break;
    case 'PW':
      result = {
        Title: isRequired ? title_postal_code : i18n.get('Address_Title_Optional', {
          title: title_postal_code
        }),
        Pattern: /^((96939)|(96939-)[0-9][0-9][0-9][0-9]|(96940)|(96940-)[0-9][0-9][0-9][0-9])$/,
        Required: isRequired,
        IsZip: false
      };
      break;
    case 'WF':
      result = {
        Title: isRequired ? title_postal_code : i18n.get('Address_Title_Optional', {
          title: title_postal_code
        }),
        Pattern: /^((986)\d{2,2})$/,
        Required: isRequired,
        IsZip: false
      };
      break;
    case 'WS':
      result = {
        Title: isRequired ? title_postal_code : i18n.get('Address_Title_Optional', {
          title: title_postal_code
        }),
        Pattern: /^(WS[1-2][0-9][0-9][0-9])$/,
        Required: isRequired,
        IsZip: false
      };
      break;
    case 'YT':
      result = {
        Title: isRequired ? title_postal_code : i18n.get('Address_Title_Optional', {
          title: title_postal_code
        }),
        Pattern: /^((976)\d{2,2}|(985)\d{2,2})$/,
        Required: isRequired,
        IsZip: false
      };
      break;
    case 'BE':
      result = {
        Title: isRequired ? title_postal_code : i18n.get('Address_Title_Optional', {
          title: title_postal_code
        }),
        Pattern: /^(1[0-9][0-9][0-9]|2[0-9][0-9][0-9]|3[0-9][0-9][0-9]|4[0-9][0-9][0-9]|5[0-6][0-9][0-9]|6[0-9][0-9][0-9]|7[0-9][0-9][0-9]|8[0-9][0-9][0-9]|9[0-9][0-9][0-9])$/,
        Required: isRequired,
        IsZip: false
      };
      break;
    default:
      result = {
        Title: isRequired ? title_postal_code : i18n.get('Address_Title_Optional', {
          title: title_postal_code
        }),
        Pattern: /.*/,
        Required: isRequired,
        IsZip: false
      };
      break;
  }
  return result;
}
function localitySchema(countryCode) {
  var result = {};
  switch (countryCode) {
    case 'HK':
    case 'TW':
      result = {
        Title: i18n.get('Address_District')
      };
      break;
    default:
      result = {
        Title: i18n.get('Address_Locality')
      };
      break;
  }
  return result;
}
function adminDistrictSchema(countryCode) {
  var result = {};
  switch (countryCode) {
    case 'VN':
    case 'PH':
    case 'PL':
    case 'TH':
    case 'TR':
    case 'ZA':
    case 'EC':
    case 'DO':
    case 'CR':
    case 'PA':
    case 'LK':
    case 'NC':
    case 'MN':
    case 'PG':
    case 'MV':
    case 'KG':
    case 'AM':
    case 'ZW':
    case 'PK':
    case 'DZ':
    case 'ZM':
    case 'GA':
    case 'RW':
    case 'SL':
    case 'VU':
    case 'BE':
      result = {
        Title: i18n.get('Address_Province')
      };
      break;
    case 'TW':
      result = {
        Title: i18n.get('Address_ProvinceCity')
      };
      break;
    case 'GR':
      result = {
        Title: i18n.get('Address_AdministrativeRegion')
      };
      break;
    case 'RO':
    case 'HU':
    case 'HR':
    case 'LT':
    case 'EE':
    case 'AL':
      result = {
        Title: i18n.get('Address_County')
      };
      break;
    case 'CZ':
    case 'SK':
    case 'BG':
    case 'IS':
    case 'GY':
    case 'MG':
    case 'TG':
    case 'TZ':
    case 'NA':
    case 'MR':
    case 'GE':
    case 'SN':
    case 'CM':
    case 'SO':
    case 'NE':
    case 'FO':
    case 'DJ':
    case 'ER':
    case 'GW':
      result = {
        Title: i18n.get('Address_Region')
      };
      break;
    case 'LV':
    case 'SM':
    case 'MK':
    case 'ME':
    case 'TT':
    case 'GU':
    case 'QA':
    case 'MP':
    case 'MH':
    case 'PM':
      result = {
        Title: i18n.get('Address_Municipality')
      };
      break;
    case 'LU':
      result = {
        Title: i18n.get('Address_Canton')
      };
      break;
    case 'PT':
    case 'CY':
    case 'SR':
    case 'BS':
    case 'KY':
    case 'BN':
    case 'MW':
    case 'SC':
    case 'LS':
    case 'IL':
    case 'MD':
    case 'MU':
    case 'TJ':
    case 'LY':
    case 'BZ':
    case 'CI':
    case 'AI':
    case 'VI':
    case 'LC':
    case 'SR':
    case 'BW':
    case 'UG':
    case 'TO':
    case 'NR':
    case 'WS':
      result = {
        Title: i18n.get('Address_District')
      };
      break;
    case 'LI':
    case 'GL':
      result = {
        Title: i18n.get('Address_Commune')
      };
      break;
    case 'AG':
    case 'AD':
    case 'DM':
    case 'MS':
    case 'BB':
    case 'GD':
    case 'JM':
    case 'BM':
    case 'KN':
    case 'VC':
    case 'MO':
      result = {
        Title: i18n.get('Address_Parish')
      };
      break;
    case 'BA':
      result = {
        Title: i18n.get('Address_Entity')
      };
      break;
    case 'BD':
    case 'FJ':
      result = {
        Title: i18n.get('Address_Division')
      };
      break;
    case 'NP':
      result = {
        Title: i18n.get('Address_Zone')
      };
      break;
    case 'UY':
    case 'GT':
    case 'BO':
    case 'HN':
    case 'PY':
    case 'SV':
    case 'HT':
    case 'BJ':
      result = {
        Title: i18n.get('Address_Department')
      };
      break;
    case 'OM':
    case 'EG':
    case 'BH':
    case 'IQ':
    case 'YE':
    case 'TN':
      result = {
        Title: i18n.get('Address_Governorate')
      };
      break;
    case 'PF':
      result = {
        Title: i18n.get('Address_AdministrativeSubdivision')
      };
      break;
    case 'KI':
      result = {
        Title: i18n.get('Address_Unit')
      };
      break;
    case 'JP':
    case 'GN':
    case 'CF':
      result = {
        Title: i18n.get('Address_Prefecture')
      };
      break;
    case 'RE':
    case 'GP':
      result = {
        Title: i18n.get('Address_Arrondissement')
      };
      break;
    case 'CC':
    case 'PW':
      result = {
        Title: i18n.get('Address_State')
      };
      break;
    case 'KM':
      result = {
        Title: i18n.get('Address_AutonomousIslands')
      };
      break;
    case 'TK':
      result = {
        Title: i18n.get('Address_AutonomousAtoll')
      };
      break;
    case 'TV':
      result = {
        Title: i18n.get('Address_Island')
      };
      break;
    case 'WF':
      result = {
        Title: i18n.get('Address_Kingdom')
      };
      break;
    default:
      result = {
        Title: i18n.get('Address_AdminDistrict')
      };
      break;
  }
  return result;
}
var formatsConfig = {
  '{{StreetAddress}}\n{{StreetAddress2}}\n{{CityName}} {{PostalCode}}\n{{CountryCode}}': ['SG', 'MS'],
  '{{StreetAddress}}\n{{StreetAddress2}}\n{{CityName}} {{ProvinceName}} {{PostalCode}}\n{{CountryCode}}': ['CA', 'PA', 'MN', 'PG', 'MV', 'KY', 'IQ', 'SO'],
  '{{StreetAddress}}\n{{StreetAddress2}}\n{{CityName}}, {{ProvinceName}} {{PostalCode}}\n{{CountryCode}}': ['US', 'AI', 'BM', 'VG', 'GI'],
  '{{StreetAddress}}\n{{StreetAddress2}}\n{{CityName}}, {{ProvinceName}}\n{{CountryCode}}': ['IE', 'GY', 'BS'],
  '{{StreetAddress}}\n{{StreetAddress2}}\n{{CityName}}\n{{CountryCode}}': ['HK', 'AW', 'DM', 'AG', 'CF', 'CK', 'DJ'],
  '{{StreetAddress}}\n{{StreetAddress2}}\n{{CityName}}\n{{ProvinceName}}\n{{PostalCode}}\n{{CountryCode}}': ['default'],
  '{{StreetAddress}}\n{{StreetAddress2}}\n{{PostalCode}} {{CityName}}\n{{CountryCode}}': ['GR', 'LU', 'CY', 'MC', 'GE', 'TN'],
  '{{StreetAddress}}\n{{StreetAddress2}}\n{{PostalCode}} {{CityName}}\n{{ProvinceName}}\n{{CountryCode}}': ['FR', 'PL', 'TR', 'ZA', 'PT', 'CZ', 'RO', 'SK', 'HR', 'SI', 'EE', 'LI', 'BA', 'AL', 'MK', 'IS', 'ME', 'DO', 'PY', 'SV', 'MQ', 'HT', 'PF', 'PF', 'UY', 'NC', 'RE', 'MW', 'IL', 'QA', 'BH', 'DZ', 'AZ', 'YE', 'ET', 'ZM', 'FO', 'SN'],
  '{{StreetAddress}}\n{{StreetAddress2}}\n{{PostalCode}}\n{{CityName}}\n{{ProvinceName}}\n{{CountryCode}}': ['PH', 'HN', 'MU', 'MD', 'OM', 'PM', 'WF', 'BE', 'GW'],
  '{{StreetAddress}}\n{{StreetAddress2}}\n{{ProvinceName}}, {{CityName}} {{PostalCode}}\n{{CountryCode}}': ['TH'],
  '{{CityName}}\n{{StreetAddress}}\n{{StreetAddress2}}\n{{PostalCode}}\n{{CountryCode}}': ['HU'],
  '{{StreetAddress}}\n{{StreetAddress2}}\n{{ProvinceName}}\n{{PostalCode}} {{CityName}}\n{{CountryCode}}': ['BG'],
  '{{StreetAddress}}\n{{StreetAddress2}}\n{{PostalCode}} {{CityName}} {{ProvinceName}}\n{{CountryCode}}': ['LT'],
  '{{StreetAddress}}\n{{StreetAddress2}}\n{{CityName}}\n{{ProvinceName}}, {{PostalCode}}\n{{CountryCode}}': ['LV', 'BN'],
  '{{StreetAddress}}\n{{StreetAddress2}}\n{{CityName}} {{ProvinceName}}\n{{PostalCode}}\n{{CountryCode}}': ['MT'],
  '{{StreetAddress}}\n{{StreetAddress2}}\n{{CityName}}, {{ProvinceName}}\n{{PostalCode}}\n{{CountryCode}}': ['JP', 'KN', 'VC'],
  '{{StreetAddress}}\n{{StreetAddress2}}\n{{ProvinceName}}\n{{CityName}}, {{PostalCode}}\n{{CountryCode}}': ['BD'],
  '{{StreetAddress}}\n{{StreetAddress2}}\n{{CityName}} {{PostalCode}}\n{{ProvinceName}}\n{{CountryCode}}': ['LK', 'TT', 'AS', 'MP', 'VI'],
  '{{StreetAddress}}\n{{StreetAddress2}}\n{{PostalCode}}-{{CityName}}, {{ProvinceName}}\n{{CountryCode}}': ['GT'],
  '{{StreetAddress}}\n{{StreetAddress2}}\n{{ProvinceName}}, {{CityName}}\n{{PostalCode}}\n{{CountryCode}}': ['CR'],
  '{{StreetAddress}}\n{{StreetAddress2}}\n{{CityName}}\n{{ProvinceName}}\n{{CountryCode}}': ['FJ', 'NA', 'ZW', 'LY', 'TG', 'MR', 'CM', 'CI', 'RW', 'BZ', 'GD', 'JM', 'SR', 'TO', 'GL', 'BW', 'GA', 'BJ', 'ER', 'KM', 'SL', 'TK', 'TV', 'VU'],
  '{{StreetAddress}}\n{{StreetAddress2}}\n{{CityName}}\n{{PostalCode}}\n{{CountryCode}}': ['EC', 'NR', 'NU', 'PN', 'WS'],
  '{{StreetAddress}}\n{{StreetAddress2}}\n{{PostalCode}}, {{CityName}}\n{{ProvinceName}}\n{{CountryCode}}': ['NG'],
  '{{PostalCode}}\n{{CountryCode}}\n{{CityName}}\n{{StreetAddress}}\n{{StreetAddress2}}\n': ['TJ'],
  '{{CountryCode}}\n{{PostalCode}}\n{{CityName}}\n{{StreetAddress}}\n': ['KG'],
  '{{StreetAddress}}\n{{StreetAddress2}}\n{{CityName}}\n{{PostalCode}}\n{{ProvinceName}}\n{{CountryCode}}': ['PK'],
  '{{CountryCode}}\n{{PostalCode}}\n{{CityName}}\n{{StreetAddress}}\n{{StreetAddress2}}\n': ['AM'],
  '{{StreetAddress}}\n{{StreetAddress2}}\n{{PostalCode}}\n{{CityName}}\n{{ProvinceName}},\n{{CountryCode}}': ['TZ'],
  '{{StreetAddress}}\n{{StreetAddress2}}\n{{ProvinceName}}\n{{CityName}}': ['SC'],
  '{{StreetAddress}}\n{{StreetAddress2}}\n{{CityName}}\n{{ProvinceName}},\n{{CountryCode}}': ['UG'],
  '{{StreetAddress}}\n{{StreetAddress2}}\n{{PostalCode}}\n{{CityName}}\n{{CountryCode}}': ['GP', 'YT'],
  '{{CountryCode}}\n{{CityName}}{{StreetAddress}}\n{{StreetAddress2}}': ['MO']
};
var formats = _.chain(formatsConfig).keys().map(function (format) {
  return formatsConfig[format].map(function (countryCode) {
    return [countryCode, format];
  });
}).flatten(1).object().value();
function displayFormat(countryCode) {
  return formats[countryCode] || formats['default'];
}
function display(model) {
  var res = putils.curlyTemplate(displayFormat(model.CountryCode))(_.defaults({
    CountryCode: model.CountryName,
    ProvinceName: model.ProvinceCode
  }, model));
  return _.chain(res.split('\n')).filter(function (line) {
    var temp = line.trim();
    return temp !== ',' && !_.isEmpty(temp);
  }).map(function (line) {
    return line.trim();
  }).value();
}
export default {
  localitySchema: localitySchema,
  postalCodeSchema: postalCodeSchema,
  adminDistrictSchema: adminDistrictSchema,
  displayFormat: displayFormat,
  display: display
};
export {
  localitySchema,
  postalCodeSchema,
  adminDistrictSchema,
  displayFormat,
  display,
};
